<button
    lsLivechatButton
    lsUiButtonKind="primary"
    lsUiButtonPalette="accent-1"
    lsUiButtonSize="small"
    [hasIcon]="true"
    [title]="'common.jivo' | translate"
>
    <ls-ui-icon
        height="24"
        src="support"
        width="24"
    />
</button>
